import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  apiFetchWhistleSkitBlownData,
  apiUpdateSkitStatus,
} from "../../api/backend/admin";
import SkitReviewCard from "../../components/skitReviewCard/skitReviewCard";
import { SolidColorButton, ImgTopBtn } from "../../components/buttons";
import {
  LeftArrowIcon,
  LineIntersectingCircleIcon,
  EyeIcon,
} from "../../components/icons";
import BlinkingLight from "../../components/blinkingLight/blinkingLight";
import "./whistleBlownSkitPage.scss";

function WhistleBlownSkitPage() {
  const [data, setData] = useState({ needsReview: [], suspended: [] });
  const [paging, setPaging] = useState({
    limit: 10,
    offsetNeedsReview: 0,
    offsetSuspended: 0,
  });
  const [filterFlags, setFilterFlags] = useState("needsReview");
  // track which skit is playing
  const [currentPlayingId, setCurrentPlayingId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    apiFetchWhistleSkitBlownData(paging).then((res) => {
      setData(res.data.data);
    });
  }, [paging]);

  const loadMore = () =>
    setPaging((p) => ({
      ...p,
      offsetNeedsReview: p.offsetNeedsReview + p.limit,
      offsetSuspended: p.offsetSuspended + p.limit,
    }));

  const handleAction = async (skitId, status) => {
    try {
      await apiUpdateSkitStatus({ skitId, status });
      setData(({ needsReview, suspended }) => ({
        needsReview: needsReview.filter((s) => s.id !== skitId),
        suspended: suspended.filter((s) => s.id !== skitId),
      }));
    } catch (err) {
      console.error("Failed to update skit status", err);
    }
  };

  const filtersFlagsList =
    filterFlags === "needsReview" ? data.needsReview : data.suspended;
  // callback to toggle play state for a given skit, so skits don't play at the same time
  // can do this but requires c programming to get closer to the chip and the network
  // this means more time to build, more oversight, and more resources needed. I won't
  // build it for those reasons though I know how. Maybe later like version 4 depending on cost and benefits analysis and demand
  const hasMore = filtersFlagsList.length >= paging.limit;
  const handlePlayToggle = (skitId) => {
    // start this one or stop if it’s already playing
    setCurrentPlayingId((prev) => (prev === skitId ? null : skitId));
  };

  return (
    <div className="whistle-blown-page">
      <SolidColorButton
        solidColorBtnImage={
          <LeftArrowIcon
            height="15px"
            width="15px"
            fillColor="#964b00"
            strokeWidth="4"
            strokeColor="#964b00"
          />
        }
        className="gold-btn"
        solidColorBtnText="Back"
        solidColorBtnFontWeight="800"
        solidColorBtnFontFamily="helvetica"
        solidColorBtnTextFontSize=".75rem"
        solidColorBtnFontColor="#964b00"
        solidColorBtnWidth="100px"
        solidColorBtnBoxShadow="0 4px 3px 1px #000000bb, 0 6px 8px #000000bb, 0 -4px 4px #000000bb, 0 -6px 4px #000000bb, inset 0 0 3px 0 #000000bb"
        onClick={() => navigate(-1)}
      />

      <div id ="topWhistleBlownSkitPage" className="filter-buttons">
        <ImgTopBtn
          image={
            <EyeIcon
              height="20px"
              width="20px"
              fillColor={
                filterFlags === "needsReview"
                  ? "var(--color-black)"
                  : "var(--color-hotRed)"
              }
              style={{ paddingRight: "5px" }}
            />
          }
          imgTopBtnText={`Needs Review (${data.needsReview.length})`}
          onClick={() => setFilterFlags("needsReview")}
          imgTopBtnWidth="200px"
          imgTopBtnFontColor={
            filterFlags === "needsReview"
              ? "var(--color-black)"
              : "var(--color-hotRed)"
          }
          className={filterFlags === "needsReview" ? "active" : ""}
        />
        <ImgTopBtn
          image={
            <LineIntersectingCircleIcon
              width="20px"
              height="20px"
              style={{ paddingRight: "5px" }}
              fillColor={
                filterFlags === "suspended"
                  ? "var(--color-black)"
                  : "var(--color-hotRed)"
              }
              strokeColor={
                filterFlags === "suspended"
                  ? "var(--color-black)"
                  : "var(--color-hotRed)"
              }
            />
          }
          imgTopBtnText={`Suspended (${data.suspended.length})`}
          onClick={() => setFilterFlags("suspended")}
          imgTopBtnWidth="200px"
          imgTopBtnFontColor={
            filterFlags === "suspended"
              ? "var(--color-black)"
              : "var(--color-hotRed)"
          }
          className={filterFlags === "suspended" ? "active" : ""}
        />
      </div>
      {/* grid wrapper */}
      <div className="reports-list">
        {filtersFlagsList.map((skit) => (
          <div key={skit.id} className="report-item">
            <SkitReviewCard
              skit={skit}
              onAction={handleAction}
              isPlaying={skit.id === currentPlayingId} // tracking which skit is playing passing to the call back to the child, one skit at a time is allowed to play, so data validation
              onPlayToggle={() => handlePlayToggle(skit.id)} // the toogle allowing each skit id to play
            />
          </div>
        ))}
      </div>
      {filtersFlagsList.length >= 10 && (
        <div className="load-more-container">
          <ImgTopBtn
            image={
              <BlinkingLight
                blinkerLightStyles={{ marginRight: "10px" }}
              />
            }
            imgTopBtnWidth="300px"
            imgTopBtnFontColor="#b03a2e"
            imgTopBtnTextFontSize="1rem"
            imgTopBtnText="View More Reports"
            onClick={loadMore}
          />
        </div>
      )}
    </div>
  );
}

export default WhistleBlownSkitPage;
